import { shuffle } from './shuffle.js'
import Letter from './Letter.js'
import audio1 from './Audio/arab01.wav'
import audio2 from './Audio/arab02.wav'
import audio3 from './Audio/arab03.wav'
import audio4 from './Audio/arab04.wav'
import audio5 from './Audio/arab05.wav'
import audio6 from './Audio/arab06.wav'
import audio7 from './Audio/arab07.wav'
import audio8 from './Audio/arab08.wav'
import audio9 from './Audio/arab09.wav'
import audio10 from './Audio/arab10.wav'
import audio11 from './Audio/arab11.wav'
import audio12 from './Audio/arab12.wav'
import audio13 from './Audio/arab13.wav'
import audio14 from './Audio/arab14.wav'
import audio15 from './Audio/arab15.wav'
import audio16 from './Audio/arab16.wav'
import audio17 from './Audio/arab17.wav'
import audio18 from './Audio/arab18.wav'
import audio19 from './Audio/arab19.wav'
import audio20 from './Audio/arab20.wav'
import audio21 from './Audio/arab21.wav'
import audio22 from './Audio/arab22.wav'
import audio23 from './Audio/arab23.wav'
import audio24 from './Audio/arab24.wav'
import audio25 from './Audio/arab25.wav'
import audio26 from './Audio/arab26.wav'
import audio27 from './Audio/arab27.wav'
import audio28 from './Audio/arab28.wav'

const arab01 = new Audio(audio1)
const arab02 = new Audio(audio2)
const arab03 = new Audio(audio3)
const arab04 = new Audio(audio4)
const arab05 = new Audio(audio5)
const arab06 = new Audio(audio6)
const arab07 = new Audio(audio7)
const arab08 = new Audio(audio8)
const arab09 = new Audio(audio9)
const arab10 = new Audio(audio10)
const arab11 = new Audio(audio11)
const arab12 = new Audio(audio12)
const arab13 = new Audio(audio13)
const arab14 = new Audio(audio14)
const arab15 = new Audio(audio15)
const arab16 = new Audio(audio16)
const arab17 = new Audio(audio17)
const arab18 = new Audio(audio18)
const arab19 = new Audio(audio19)
const arab20 = new Audio(audio20)
const arab21 = new Audio(audio21)
const arab22 = new Audio(audio22)
const arab23 = new Audio(audio23)
const arab24 = new Audio(audio24)
const arab25 = new Audio(audio25)
const arab26 = new Audio(audio26)
const arab27 = new Audio(audio27)
const arab28 = new Audio(audio28)

// Constructor of Letter: (id, latin, arabic, name)
const ba = new Letter(1, "b", "ب", "bāʾ", arab01)
const ta = new Letter(2, "t", "ت", "tāʾ", arab02)
const tha = new Letter(3, "th", "ث", "thāʾ", arab03)
const gim = new Letter(4, "zh", "ج", "ǧīm", arab04)
const alif = new Letter(5, "a", "ا", "ʾalif", arab05)
const ha2 = new Letter(6, "H", "ح", "ḥāʾ", arab06)
const kha = new Letter(7, "kh", "خ", "khāʾ", arab07)
const dal = new Letter(8, "d", "د", "dāl", arab08)
const dhal = new Letter(9, "dh", "ذ", "dhāl", arab09)
const ra = new Letter(10, "r", "ر", "rāʾ", arab10)
const zayn = new Letter(11, "z", "ز", "zayn", arab11)
const sin = new Letter(12, "s", "س", "sīn", arab12)
const shin = new Letter(13, "sh", "ش", "shīn", arab13)
const sad = new Letter(14, "S", "ص", "ṣād", arab14)
const dad = new Letter(15, "D", "ض", "ḍād", arab15)
const ta2 = new Letter(16, "T", "ط", "ṭāʾ", arab16)
const za = new Letter(17, "DH", "ظ", "ẓāʾ", arab17)
const ayn = new Letter(18, "ʿ", "ع", "ʿayn", arab18)
const ghayn = new Letter(19, "gh", "غ", "ghayn", arab19)
const fa = new Letter(20, "f", "ف", "fāʾ", arab20)
const qaf = new Letter(21, "q", "ق", "qāf", arab21)
const kaf = new Letter(22, "k", "ك", "kāf", arab22)
const lam = new Letter(23, "l", "ل", "lām", arab23)
const mim = new Letter(24, "m", "م", "mīm", arab24)
const nun = new Letter(25, "n", "ن", "nūn", arab25)
const ha = new Letter(26, "h", "ه", "hāʾ", arab26)
const waw = new Letter(27, "w", "و", "wāw", arab27)
const ya = new Letter(28, "i", "ي", "yāʾ", arab28)

const letters = [ba,ta,tha,gim,alif,ha2,kha,dal,dhal,ra,zayn,sin,shin,
  sad,dad,ta2,za,ayn,ghayn,fa,qaf,kaf,lam,mim,nun,ha,waw,ya]
const set1 = [alif, waw, ya]
const set2 = [ba, ta, tha]
const set3 = [gim, ha2, kha]
const set4 = [dal, dhal, ra]
const set5 = [zayn, sin, shin]
const set6 = [sad, dad, ta2, za]
const set7 = [ayn, ghayn, fa, qaf]
const set8 = [kaf, lam, mim, nun, ha]

class Abjad {
  constructor() {
    this.arr = letters
  }

  getRandomLetter() {
    const randomNum = Math.floor(Math.random() * Math.floor(this.arr.length))
    return this.arr[randomNum]
  }

  getSet(set) {
    set = parseInt(set)
    switch (set) {
      case 1:
        return set1
      case 2:
        return set2
      case 3:
        return set3
      case 4:
        return set4
      case 5:
        return set5
      case 6:
        return set6
      case 7:
        return set7
      case 8:
        return set8
      default:
      return this.getQuestionSet(9)
    }
  }

  getQuestionSet(howMany) {
    shuffle(letters)
    const result = []
    for (let i = 0; i < howMany; i++) {
      result.push(letters[i])
    }
    return result
  }

  compare(a, b) {
    return (a.latin === b.latin || a.arabic === b.arabic)
  }
}

export default Abjad
